export default __webpack_public_path__ + "static/media/bg1.8a2411e8.jpg";